/* unplugin-vue-components disabled */import script from "./emailDiv.vue?vue&type=script&setup=true&lang=js"
export * from "./emailDiv.vue?vue&type=script&setup=true&lang=js"

import "./emailDiv.vue?vue&type=style&index=0&id=1786e7f4&scoped=true&lang=css"

import exportComponent from "D:\\00JH-项目\\钧舵机器人\\en\\jodell_robotics\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1786e7f4"]])

export default __exports__